import { createFileRoute } from "@tanstack/react-router";
import { Box } from "@salestrak/ui";

import { IssuesTable } from "#app/components/issues/issues-table";
import { PageHeader } from "#app/components/page-header";
import { IssueFilterProvider } from "#app/lib/filters/issue-filter-context";
import { AnalyticsScope } from "#app/lib/analytics";

// Viewer-relative and id-less, so one constant serves every render.
const SHARED_SCOPE = { kind: "shared" } as const;

/**
 * `/shared` — the projects other people have shared with the viewer, across
 * every workflow, rendered by the shared {@link IssuesTable} grouped by
 * workflow. Spaces still lists each workflow the viewer can reach, scoped to
 * what they may see there; this list is the cross-workflow answer to "what did
 * someone hand me?". Reachable by any role — sharing is not a Guest-only act.
 */
function SharedWithMeScreen() {
  return (
    <IssueFilterProvider analyticsScope={AnalyticsScope.Shared}>
      <Box direction="column" fill="flex">
        <PageHeader title="Shared with me" />
        <IssuesTable scope={SHARED_SCOPE} />
      </Box>
    </IssueFilterProvider>
  );
}

export const Route = createFileRoute("/(app)/$workspace/shared")({
  component: SharedWithMeScreen,
});
